import {
  Modal,
  Fade,
  Backdrop,
  Box,
  Typography,
  IconButton,
  TextField,
  Button,
  CircularProgress,
  Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function ExpertModal({
  open,
  onClose,
  formData,
  handleChange,
  handleSubmit,
  loading,
  error,
  success,
  luxuryInput,
  luxuryButton,
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 400,
          sx: {
            backgroundColor: "rgba(10,10,10,0.85)",
            backdropFilter: "blur(10px)",
          },
        },
      }}
    >
      <Fade in={open}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "92%", sm: 420 },
            borderRadius: "28px",
            p: { xs: 3.5, md: 4.5 },
            backgroundColor: "var(--color-white)",
            boxShadow: "0 45px 120px rgba(0,0,0,0.5)",
            outline: "none",
          }}
        >
          {/* CLOSE */}
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              color: "var(--color-text-muted)",
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* HEADER */}
          <Typography
            sx={{
              fontSize: 22,
              fontWeight: 600,
              color: "var(--color-text-primary)",
              mb: 1,
            }}
          >
            Speak With An Expert
          </Typography>

          <Typography
            sx={{
              fontSize: 14,
              color: "var(--color-text-muted)",
              mb: 3,
              lineHeight: 1.7,
            }}
          >
            Confidential consultation with our luxury real estate advisors.
          </Typography>

          {/* FORM */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2.2 }}>
            <TextField
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              fullWidth
              size="small"
              sx={luxuryInput}
            />

            <TextField
              name="phone"
              placeholder="Mobile Number"
              value={formData.phone}
              onChange={handleChange}
              fullWidth
              size="small"
              sx={luxuryInput}
            />

            <TextField
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              fullWidth
              size="small"
              sx={luxuryInput}
            />

            {error && <Alert severity="error">{error}</Alert>}
            {success && <Alert severity="success">{success}</Alert>}

            <Button
              sx={{ ...luxuryButton, mt: 2, height: 54 }}
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={22} sx={{ color: "#1c1c1c" }} />
              ) : (
                "Submit Request"
              )}
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}
